module.exports = __webpack_public_path__ + "static/media/refund.16225604.png";